import { render, staticRenderFns } from "./MakeMemberMngChat.vue?vue&type=template&id=153d8967&scoped=true&"
import script from "./MakeMemberMngChat.vue?vue&type=script&lang=js&"
export * from "./MakeMemberMngChat.vue?vue&type=script&lang=js&"
import style0 from "./MakeMemberMngChat.vue?vue&type=style&index=0&id=153d8967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d8967",
  null
  
)

export default component.exports